import React from 'react'
import MoreActionModals from './containers/authorised/dashboard/quickActions/MoreActionModals'

export default function ModalRendering(props) {
  // component for modals
  const {isPdf } = props

  return (
    <>
      <MoreActionModals isPdf={isPdf} />
    </>
  )
}
